<template>
  <div>
    <div
      v-for="attribute in attributes"
      :key="attribute.id"
      class="filter-group"
    >
      <div v-if="!attribute.hide">
        <div v-if="attribute.slider">
          <app-slider
            :attribute="attribute"
            @updateQuery="handleUpdateQuery"
            @removeQueryAttr="handleRemoveQueryAttr"
          ></app-slider>
        </div>
        <div v-else>
          <app-checkboxes
            :attribute="attribute"
            @updateQuery="handleUpdateQuery"
            @removeQueryAttr="handleRemoveQueryAttr"
          ></app-checkboxes>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "./Slider.vue";
import Checkboxes from "./Checkboxes.vue";

export default {
  components: {
    appSlider: Slider,
    appCheckboxes: Checkboxes
  },
  computed: {
    attributes() {
      return this.$store.getters.attributes;
    }
  },
  methods: {
    handleUpdateQuery(filterAttr) {
      let query = Object.assign({}, this.$route.query);

      let attributes = [];

      if (typeof query.attributes != "undefined" && query.attributes.length) {
        attributes = JSON.parse(query.attributes);
      } else {
        query.attributes = [];
      }

      const foundIndex = attributes.findIndex(
        attribute => attribute.id == filterAttr.id
      );

      if ( filterAttr.slider  ) {
        if (foundIndex != -1) {
          let attribute = attributes[foundIndex];
          attribute.min = filterAttr.min;
          attribute.max = filterAttr.max;
        } else {
          attributes.push({
            id: filterAttr.id,
            slider: filterAttr.slider,
            min: filterAttr.min,
            max: filterAttr.max
          });
        }
      } else {
        if (foundIndex != -1) {
          let attribute = attributes[foundIndex];
          attribute.values = filterAttr.values;
        } else {
          attributes.push({
            id: filterAttr.id,
            slider: filterAttr.slider,
            values: filterAttr.values,
          });
        }
      }

      query.attributes = JSON.stringify(attributes);

      this.$router
        .push({
          name: "Catalog",
          query
        })
        .catch(err => {});
    },
    handleRemoveQueryAttr(attrId) {
      let query = Object.assign({}, this.$route.query);

      let attributes = [];

      if (typeof query.attributes != "undefined" && query.attributes.length) {
        attributes = JSON.parse(query.attributes);
      } else {
        query.attributes = [];
      }

      //  Check if exists
      const foundIndex = attributes.findIndex(
        attribute => attribute.id == attrId
      );

      if (foundIndex != -1) {
        attributes.splice(foundIndex, 1);
      }

      if (attributes.length) {
        query.attributes = JSON.stringify(attributes);

        this.$router
          .push({
            name: "Catalog",
            query
          })
          .catch(err => {});
      } else {
        delete query.attributes;

        this.$router
          .replace({
            name: "Catalog",
            query
          })
          .catch(err => {});
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/filter/Attributes.vue